import React, { useState, useEffect } from 'react';
import { Tabs, Switch, Alert, Spin, message } from 'antd'
import { useLocation } from 'react-router-dom'
import AccountNoData from "../../Management/CreditReportSetup/AccountNoData"
import CreditAccountList from "../../Management/CreditReportSetup/CreditAccountList"
import CreditAccountModal from "../../Management/CreditReportSetup/CreditAccountModal"
import CreditPullPaymentModal from "./CreditPullPaymentModal"
import { normalizeBorrowerPaidPolicy } from "../../Management/CreditReportSetup/creditPricingUtils"
import './index.css'
import { track } from 'statsig'
import { STATSIG, PAGE, pageByMenu } from 'statsig/events'

const CreditReport = () => {
    const location = useLocation()
    const tabFromQuery = new URLSearchParams(location.search).get('tab')
    const initialTab =
        location.state?.creditReportTab === 'HardPull' || tabFromQuery === 'HardPull'
            ? 'HardPull'
            : 'SoftPull'
    const [isAccounTModalOpen, setAccounTModalOpen] = useState(false)
    const [activeTab, setActiveTab] = useState(initialTab)
    const [showAlert, setShowAlert] = useState(false)
    const [featureCreditAccounts, setFeatureCreditAccounts] = useState([])
    const [handleType, setHandleType] = useState('')
    const [handleIndex, setHandleIndex] = useState(0)
    const [connectStatus, setConnectStatus] = useState('success')
    const [accountList, setAccountList] = useState([])
    const [borrowerPaidPolicy, setBorrowerPaidPolicy] = useState(normalizeBorrowerPaidPolicy(null))
    const [paymentPreference, setPaymentPreference] = useState(null)
    const [paymentModalOpen, setPaymentModalOpen] = useState(false)
    const [paymentAccount, setPaymentAccount] = useState(null)
    const [initialValues, setInitialValues] = useState({
        Vendor: undefined,
        Username: "",
        Password: "",
        UseEquifax: true,
        UseExperian: true,
        UseTransUnion: true,
        IsDefault: false,
        AutomatedSoftCreditPull: false,
        Type: 'SoftPull'
    })
    const [softCreditStatus, setSoftCreditStatus] = useState(false)
    const [loading, setLoading] = useState(false)
    const [switchLoading, setSwitchLoading] = useState(false)
    useEffect(() => {
        const page = pageByMenu(PAGE.MGMT_CREDIT_REPORT, PAGE.CREDIT_REPORT)
        track(STATSIG.COMMON.VIEW, page, { page })
        getAllAccouts()
    }, [])
    useEffect(() => {
        const tab = new URLSearchParams(location.search).get('tab')
        if (tab === 'HardPull' || tab === 'SoftPull') {
            setActiveTab(tab)
        } else if (location.state?.creditReportTab === 'HardPull' || location.state?.creditReportTab === 'SoftPull') {
            setActiveTab(location.state.creditReportTab)
        }
    }, [location.search, location.state])
    const tabsOnChange = (key) => {
        setActiveTab(key)
        const tab = key === 'HardPull' ? 'hard_pull' : 'soft_pull'
        track(STATSIG.CREDIT_REPORT.TAB, tab, { tab })
    }
    const connectAccount = () => {
        setHandleType('add')
        setInitialValues(prevValues => ({
            ...prevValues,
            Type: activeTab
        }))
        setAccounTModalOpen(true)
    }
    const handleAccount = (item, type) => {
        if (type === 'edit') {
            setHandleType('edit')
            setHandleIndex(item.originalIndex)
            setAccounTModalOpen(true)
            setInitialValues(item)
        } else if (type === 'remove') {
            setHandleType('remove')
            const updatedAccounts = featureCreditAccounts.filter(account => account.originalIndex !== item.originalIndex)
            const nextAccounts = updatedAccounts.map(({ originalIndex, ...rest }) => rest)
            setFeatureCustomization({ CreditAccounts: nextAccounts }, 'account', 'remove').then((ok) => {
                if (ok) {
                    message.success('Credit account removed.')
                } else {
                    message.error('Unable to remove the credit account.')
                }
            })
        } else {
            const updatedAccounts = featureCreditAccounts.map(account =>
                account.originalIndex === item.originalIndex
                    ? { ...account, IsDefault: true }
                    : account.Type === item.Type
                        ? { ...account, IsDefault: false }
                        : account
            )
            const nextAccounts = updatedAccounts.map(({ originalIndex, ...rest }) => rest)
            setFeatureCustomization({ CreditAccounts: nextAccounts }, 'account', 'default')
        }
    }

    const getCreditaccountconfig = async () => {
        try {
            let token = sessionStorage.getItem("ZeitroA")
            const response = await fetch(`/los/getcreditaccountconfig`, {
                method: 'get',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            return await response.json()
        } catch (error) {
            return null
        }
    }
    const getFeatureCustomization = async () => {
        try {
            let token = sessionStorage.getItem("ZeitroA")
            const response = await fetch(`/los/getfeaturecustomization`, {
                method: 'get',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            return await response.json()
        } catch (error) {
            return null
        }
    }

    const setFeatureCustomization = async (data, type, handleTypeValue = handleType) => {
        try {
            if (type === 'switch') {
                setSwitchLoading(true)
            } else {
                setLoading(true)
            }
            let token = sessionStorage.getItem("ZeitroA")
            const response = await fetch(`/los/setfeaturecustomization`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                },
            })
            if (!response.ok) {
                throw new Error(await response.text() || 'Save failed')
            }
            await getAllAccouts()
            const pullType = activeTab === 'HardPull' ? 'hard_pull' : 'soft_pull'
            if (type === 'switch') {
                const enabled = data.AutomatedCreditPull ? 'true' : 'false'
                track(STATSIG.CREDIT_REPORT.ALLOW_SOFT_PULL_SWITCH, enabled, { enabled })
                setSwitchLoading(false)
            } else {
                if (handleTypeValue === 'remove') {
                    track(STATSIG.CREDIT_REPORT.REMOVE, pullType, { type: pullType })
                } else if (handleTypeValue === 'edit') {
                    track(STATSIG.CREDIT_REPORT.UPDATE, pullType, { type: pullType })
                } else if (handleTypeValue === 'add') {
                    track(STATSIG.CREDIT_REPORT.CONNECT_NEW_ACCOUNT, pullType, { type: pullType })
                } else if (handleTypeValue === 'default') {
                    track(STATSIG.CREDIT_REPORT.SET_AS_DEFAULT, pullType, { type: pullType })
                }
                if (handleTypeValue !== 'remove') {
                    setConnectStatus('success')
                    showConnectAlert()
                }
                setLoading(false)
            }
            return true
        } catch (error) {
            setLoading(false)
            setSwitchLoading(false)
            if (handleTypeValue !== 'remove') {
                setConnectStatus('fail')
                showConnectAlert()
            }
            return false
        }
    }

    const getAllAccouts = async () => {
        try {
            setLoading(true)
            const [creditAccountConfig, featureCustomization] = await Promise.all([
                getCreditaccountconfig(),
                getFeatureCustomization()
            ])

            setSoftCreditStatus(featureCustomization?.AutomatedCreditPull)
            setBorrowerPaidPolicy(normalizeBorrowerPaidPolicy(creditAccountConfig?.BorrowerPaidPolicy))
            setPaymentPreference(featureCustomization?.CreditPullPaymentPreference || null)
            const nextFeatureAccounts = (featureCustomization?.CreditAccounts || []).map((account, index) => ({
                ...account,
                originalIndex: index
            }))
            const adminCreditAccounts = (creditAccountConfig?.Accounts || []).map(account => {
                const hasDefault = nextFeatureAccounts.some(featureAccount =>
                    featureAccount.Type === account.Type && featureAccount.IsDefault
                )
                return {
                    ...account,
                    IsDefault: !hasDefault,
                    isAdminConfig: true
                }
            })

            setFeatureCreditAccounts(nextFeatureAccounts)
            setAccountList([...nextFeatureAccounts, ...adminCreditAccounts])
        } catch (error) {
            console.error("Error fetching all data:", error)
        } finally {
            setLoading(false)
        }
    }

    const handleChangeSoftcredit = (e) => {
        setFeatureCustomization({ AutomatedCreditPull: e }, 'switch')
    }
    const showConnectAlert = () => {
        setShowAlert(true)
        setTimeout(() => {
            setShowAlert(false)
        }, 5000)
    }
    const onFinish = (value) => {
        if (handleType === 'add') {
            const newAccount = {
                ...value,
                UseEquifax: true,
                UseExperian: true,
                UseTransUnion: true,
                AutomatedSoftCreditPull: false,
            }
            const sanitizedFeatureCreditAccounts = featureCreditAccounts.map(({ originalIndex, ...rest }) => rest)
            const updatedAccountList = newAccount.IsDefault
                ? sanitizedFeatureCreditAccounts.map(account =>
                    account.Type === activeTab ? { ...account, IsDefault: false } : account
                )
                : sanitizedFeatureCreditAccounts

            let nextAccountList = [...updatedAccountList]

            if (activeTab === 'SoftPull' && newAccount.Type === 'HardPull') {
                nextAccountList.push(
                    { ...newAccount, Type: 'HardPull', IsDefault: false },
                    { ...newAccount, Type: 'SoftPull', IsDefault: newAccount.IsDefault },
                )
            } else if (activeTab === 'HardPull' && newAccount.Type === 'SoftPull') {
                nextAccountList.push(
                    { ...newAccount, Type: 'SoftPull', IsDefault: false },
                    { ...newAccount, Type: 'HardPull', IsDefault: newAccount.IsDefault },
                )
            } else {
                nextAccountList.push(newAccount)
            }
            setFeatureCustomization({ CreditAccounts: nextAccountList }, 'account')
        } else {
            const updatedAccounts = featureCreditAccounts.map(account =>
                account.originalIndex === handleIndex
                    ? { ...account, ...value }
                    : account
            )
            const finalUpdatedAccounts = value.IsDefault
                ? updatedAccounts.map(account =>
                    account.Type === value.Type && account.originalIndex !== handleIndex
                        ? { ...account, IsDefault: false }
                        : account
                )
                : updatedAccounts
            const nextAccounts = finalUpdatedAccounts.map(({ originalIndex, ...rest }) => rest)
            setFeatureCustomization({ CreditAccounts: nextAccounts }, 'account')
        }
    }
    const creditAccountCancel = () => {
        setInitialValues({
            Vendor: undefined,
            Username: "",
            Password: "",
            UseEquifax: true,
            UseExperian: true,
            UseTransUnion: true,
            IsDefault: false,
            AutomatedSoftCreditPull: false,
            Type: 'SoftPull'
        })
        setAccounTModalOpen(false)
    }
    const savePaymentPreference = async (preference) => {
        try {
            setLoading(true)
            const token = sessionStorage.getItem("ZeitroA")
            await fetch(`/los/setfeaturecustomization`, {
                method: 'POST',
                body: JSON.stringify({ CreditPullPaymentPreference: preference }),
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                },
            })
            await getAllAccouts()
            setPaymentModalOpen(false)
            message.success('Credit pull payment preference saved.')
        } catch (error) {
            message.error('Unable to save payment preference.')
            setLoading(false)
        }
    }
    const accountData = accountList
        .filter(item => item.Type === activeTab)
        .sort((a, b) => {
            if (a.IsDefault && !b.IsDefault) return -1
            if (!a.IsDefault && b.IsDefault) return 1
            return 0
        })
    const tabsItems = [
        { key: 'SoftPull', label: 'Soft credit check' },
        { key: 'HardPull', label: 'Hard credit check' },
    ]
    return (
        <div className="settings-credit-report">
            <div className="creditReport-setup-title">
                Credit report setup
            </div>
            <Tabs className="creditReport-setup-tabs" activeKey={activeTab} items={tabsItems} onChange={tabsOnChange} />
            <Spin spinning={loading}>
                <div className="creditReport-setup-content">
                    {activeTab === 'SoftPull' && (
                        <Spin spinning={switchLoading}>
                            <div className="soft-credit-pull">
                                <div className="credit-pull-switch">
                                    <div className="credit-pull-title">Allow borrower to initiate soft credit pull</div>
                                    <Switch checked={softCreditStatus} onChange={handleChangeSoftcredit}></Switch>
                                </div>
                                <div className="credit-pull-description">
                                    When enabled, borrowers automatically undergo soft credit checks as part of their application.
                                </div>
                            </div>
                        </Spin>
                    )}
                    <div className="credit-accounts">
                        <div className="credit-accounts-title">Connected credit accounts</div>
                        {showAlert && connectStatus === 'fail' && (
                            <Alert className="connect-alert connect-fail" message="Unable to connect the credit account. Please try again." type="error" showIcon icon={<img src='/images/user-connect-fail.svg' />} />
                        )}
                        {showAlert && connectStatus === 'success' && (
                            <Alert className="connect-alert connect-success" message="Credit account has been successfully connected." type="success" showIcon icon={<img src='/images/user-connect-success.svg' />}/>
                        )}
                        {accountData.length === 0 ? (
                            <AccountNoData mode="personal" connectAccount={connectAccount}></AccountNoData>
                        ) : (
                            <CreditAccountList
                                mode="personal"
                                accountList={accountData}
                                handleAccount={handleAccount}
                                connectAccount={connectAccount}
                                borrowerPaidPolicy={borrowerPaidPolicy}
                                onOpenCreditPullPayment={(account) => {
                                    setPaymentAccount(account)
                                    setPaymentModalOpen(true)
                                }}
                            />
                        )}
                    </div>
                </div>
            </Spin>
            <CreditAccountModal
                open={isAccounTModalOpen}
                mode="personal"
                handleType={handleType}
                activeTab={activeTab}
                initialValues={initialValues}
                onFinish={onFinish}
                onCancel={creditAccountCancel}
            />
            <CreditPullPaymentModal
                open={paymentModalOpen}
                account={paymentAccount}
                borrowerPaidPolicy={borrowerPaidPolicy}
                paymentPreference={paymentPreference}
                onCancel={() => setPaymentModalOpen(false)}
                onSave={savePaymentPreference}
            />
        </div>
    )
}

export default CreditReport
